import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=72326e2f&scoped=true&"
import script from "./file-input.vue?vue&type=script&lang=js&"
export * from "./file-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72326e2f",
  null
  
)

export default component.exports